export default __webpack_public_path__ + "static/media/Banner - Artisan Pro - Brown.2144b267.jpg";